import styled,{css} from 'styled-components';
export const Container = styled.li`
    display: flex;
    flex-direction: column;
    justify-content: space-between; 
    margin-bottom: 0.5rem;
    border-radius: 4px;
    background-color: transparent;

    ${({isStatus})=> isStatus 
      ?css`
        background-color: ${({isOnline})=> isOnline  ?'#1c8e3e66' :'#8f8f8f3d'};
      `
      :css`
        background-color:#8f8f8f3d;
      `
    }
`
export const Content = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
`
export const Info = styled.div`
    display: flex;
    align-items: center;
    justify-content: left;
    flex: 1;
    flex-direction: row;
    overflow: hidden;
    .description--{
        display: flex;
        width: 100%;
        height: 100%;
        flex-direction: column;
    }
    .name{
        font-size: 1.2rem;
        font-weight: 500;
        color: black;
    }
    .line--{
        display: flex;
        width: 100%;
        height: 100%;
        align-items: center;
        flex-direction: column;
        p{
            display: flex;
            width: 100%;
            max-width: 100%;
            height: 100%;
            align-items: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    .isStatus{
        height: 50%;
    }
    .circle--on{
        width:15px;
        height: 15px;
        border-radius: 50%;
        margin-right: 0.3rem;
        background-color: #1e8e3e;
    }
    .circle--off{
        width:15px;
        height: 15px;
        border-radius: 50%;
        margin-right: 0.3rem;
        background-color: #8f8f8f;
    }
`
export const Actions = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    padding: 0 0.5rem;
`
export const AvatarArea = styled.div`
    width: 4rem;
    min-width: 4rem;
    height: 4rem;
    min-height: 4rem;
    padding: 0.3rem;
    margin-right: 0.5rem;
`
export const Button = styled.button`
    outline: none;
    height: 2rem;
    width: 5.5rem;
    border: 1px solid;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 0.5rem;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.8rem;
    font-weight:bold;
    margin-right: 2px;
`
export const Note = styled.div`
    position: absolute;
    display: flex;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    flex-direction: column;
    align-items: center;
    padding: 2rem;
    gap:1rem;
    background-color: #f6f6f6;


    label{
        display: flex;
        width: 100%;
        height: 2rem;
        justify-content: left;
        align-items: center;
        font-size: 1.1rem;
        font-weight:500;
        color: #000;
    }


    .text-area{
       width: 100%;
       height: 30rem;

        textArea{
            border: none;
            resize: none;
            width: 100%;
            height: 100%;
            padding: 0.5rem;
            border-radius: 6px;
            border: 1px solid #dee2e6;
            font-family: inherit;


            &:focus{
                outline:none;
            }
        }
    }
    .list{
       width: 100%;
    }

    .action{
        display: flex;
        width: 100%;
        height: 100%;
        align-items: flex-end;
        justify-content: end;
    }

`
export const Load = styled.div`
    border: 2px solid #000; 
    border-top: 2px solid #0000; 
    border-radius: 50%;
    width: 20px;
    height: 20px;
    animation: spin 1s linear infinite;
    margin-left: 2px;
  
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`
